import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import {
  Wrapper, StyledContainer, GraphicBlock, StyledLink,
} from './styles';

// * connect image left / right

// * Component {string} The name of the component / className that should render this data
// * title {RichText} title of the section
// * subheading {RichText} subheading for the section
// * items {array} of data objs for each graphic beside text block
// * ctaLink {obj} contains the url for the link
// * ctaText {string} innerText of a CTA
// * ctaType {string} className to control CTA style

function GrapicInfoSection({ sectionId, data, className }) {
  if (!data) return null;
  const {
    component,
    titleHtml,
    subheadingHtml,
    items,
    ctaLink,
    ctaText,
    ctaType,
    colourOverrideBackground,
    colourOverrideText,
    ariaLabel,
    queryString,
    lang,
  } = data;

  const style = component ? component.toLowerCase().split(' ').join('-') : '';

  return (
    <Wrapper
      id={sectionId}
      className={[className, style]}
      colourOverrideBackground={colourOverrideBackground}
      colourOverrideText={colourOverrideText}
    >
      <StyledContainer className="auto-margin">
        {/* Don't render empty tags! */}
        {titleHtml.length >= 10 && ReactHtmlParser(titleHtml)}
        {subheadingHtml.length >= 10 && ReactHtmlParser(subheadingHtml)}
        {items.map((item, index) => (
          <GraphicBlock
            key={`graphic-block-${style}-${index.toString()}`}
            className={style}
            data={item}
          />
        ))}
        {ctaLink && ctaText && (
          <StyledLink
            className={ctaType}
            to={`${ctaLink.url}/`}
            ariaLabel={ariaLabel}
            queryString={queryString}
            lang={lang}
          >
            {ctaText}
          </StyledLink>
        )}
      </StyledContainer>
    </Wrapper>
  );
}

GrapicInfoSection.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
  sectionId: PropTypes.string.isRequired,
};

GrapicInfoSection.defaultProps = {
  className: null,
};

export default GrapicInfoSection;
